import { memo } from 'react';
import { Flex, Divider, Box, Text, DataList, DataItem } from '@cad-arc';
import { CommonSize, getOneSizeSmaller } from '../../../../common/helpers/utils';
import { getDataItemText } from '../../../../common/helpers/component-utils';

export const AmlCallerInfo = memo(function AmlCallerInfo({
    callerReportingParty,
    callerPhoneNumber,
    size,
}: {
    callerReportingParty?: string;
    callerPhoneNumber?: string;
    size?: CommonSize;
}): React.ReactElement {
    const smallerSize = getOneSizeSmaller(size);

    return (
        <>
            <Flex direction="column" padding="12px 19px">
                <Box marginBottom={3}>
                    <Text variant="headingXs">Caller Info</Text>
                </Box>
                <DataList direction="column" variant="stacked" spacing={3}>
                    <DataItem
                        dataKey={<Text fontSize={smallerSize}>Reporting Party</Text>}
                        style={{ wordBreak: 'break-word' }}
                    >
                        {getDataItemText(size, callerReportingParty)}
                    </DataItem>
                    <DataItem
                        dataKey={<Text fontSize={smallerSize}>Phone</Text>}
                        style={{ wordBreak: 'break-word' }}
                    >
                        {getDataItemText(size, callerPhoneNumber)}
                    </DataItem>
                </DataList>
            </Flex>
            <Divider />
        </>
    );
});
